// extracted by mini-css-extract-plugin
export var askAiIcon = "_mf-9";
export var container = "_mf-0";
export var groupSeparator = "_mf-a";
export var highlight = "_mf-4";
export var resultIcon = "_mf-5";
export var resultItem = "_mf-7";
export var resultSubtitle = "_mf-3";
export var resultTitle = "_mf-2";
export var resultsList = "_mf-1";
export var searchGroup = "_mf-6";
export var selected = "_mf-8";